import { Button, Headline, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC } from 'react';

import { AccountSettingsStore } from '../../stores/account-settings.store';

export const AccountSettingsHeader: FC = observer(() => {
    const [{ isFormStateChanged, editUserDetails }] = useDependencies(AccountSettingsStore);
    return (
        <Stack className="p-t-3" alignItems="center" justifyContent="space-between">
            <Stack.Item>
                <Headline className="m-b-0" size="medium">
                    Account Settings
                </Headline>
            </Stack.Item>
            <Stack.Item>
                <Button
                    outline
                    id="account_save_changes_btn"
                    onClick={editUserDetails}
                    primary
                    disabled={!isFormStateChanged}
                >
                    Save Changes
                </Button>
            </Stack.Item>
        </Stack>
    );
});
